import BasicModal from 'components/component_lib/BasicModal';
import React from 'react';

const modalStyle = {
  p: {
    fontSize: '16px',
    padding: '0 1.5rem 1.5rem',

    '&:first-of-type': {
      paddingTop: '1.5rem'
    }
  }
};

export default function BankVerificationModal({ open, handleClose }) {
  return (
    <BasicModal
      open={open}
      headerText='Bank Verification Terms of Service'
      handleClose={handleClose}
      printId='bank-verification-body'
    >
      <div id='bank-verification-body' css={modalStyle}>
        <p>
          We ask you to verify your authority and access to external financial
          accounts, confirm your ability to access such accounts, and verify
          your financial information as part of the application process (“Bank
          Verification”). The Bank Verification process is subject to the
          following terms and conditions (“Terms”). Proceeding with Bank
          Verification constitutes your assent to and acceptance of these terms
          and conditions.
        </p>
        <p>
          As used hereafter, the terms “you” or “your” shall mean the consumer
          submitting an application, and the terms “we” or “our” shall refer to
          Opportunity Financial, LLC.
        </p>
        <p>
          <strong>
            <u>Application Verification Process</u>.
          </strong>
          &nbsp;We may verify your bank account by using one (1) of the methods
          set forth below:
          <br />
          <br />
          <ol>
            <li>
              <strong>
                <u>Bank Account Verification</u>
                &nbsp;(“BV”):
              </strong>
              &nbsp;It may be possible to verify your bank account quickly and
              securely through the automated BV process. If you choose to
              proceed with the BV process, we will ask you to provide your
              online banking information to third-party BV processing partners
              (“Processing Partners”), and by entering your online banking
              information now or in the past, you grant authority to our
              Processing Partners to use your online banking credentials in
              furtherance of this application and applications for additional
              financial products that you may apply for on the OppLoans website
              in the future. By choosing BV to process and verify your banking
              information, you authorize OppLoans to access secure, read-only
              reports of your banking data (“BV Reports”) from the Processing
              Partners as necessary to complete any of your credit applications
              and verify your eligibility for the financial products offered
              through the OppLoans website. OppLoans and its lending partners do
              not store your user ID, password, or any other online banking
              credentials. This service is currently only available during the
              application process through the OppLoans website. If you are
              unable to complete the BV process or choose to not utilize BV
              option, you may be required to verify your bank account using the
              Standard Bank Account Verification method set forth below which
              may cause delays in the completion of your application.
            </li>

            <li>
              <strong>
                <u>Standard Bank Account Verification</u>:
              </strong>
              &nbsp;If you are unable to use the BV system or choose to not
              utilize the BV option, in order to complete your application, you
              will be required to securely upload bank documentation via the
              OppLoans customer portal for your loan application. Failure to
              provide the required documentation will cause your application to
              be delayed and remain incomplete.
            </li>
          </ol>
        </p>
        <p>
          <strong>
            <u>Please Note</u>:
          </strong>
          &nbsp;All applicants must verify their bank account information by one
          of the above methods in order to be eligible for a loan through
          OppLoans. You understand and acknowledge that providing your bank
          account information as part of your loan application does not
          represent or imply that your loan application has been, or will be,
          approved. Please contact us if you have any questions at&nbsp;
          <strong>
            <a href={`mailto:${window.AppConfig.state.info_email}`}>
              {window.AppConfig.state.info_email}
            </a>
          </strong>
          &nbsp;or&nbsp;
          <strong>
            <a href={`tel:${window.AppConfig.state.phone}`}>
              {window.AppConfig.state.phone}
            </a>
          </strong>
          .
        </p>
        <p>
          <strong>Supplemental Verification of Active Accounts.</strong>
          &nbsp;OppLoans and its lending partners may from time to time use our
          Processing Partners to confirm the bank account that you have provided
          is open and active.
        </p>
      </div>
    </BasicModal>
  );
}
